import React from "react";
import NewPageSection from "../sections/NewsPageSection/Content";
const NewsPage = () => {
  return <NewPageSection />;
};

export default NewsPage;
